import { NGXLogger } from 'ngx-logger';
import { Component, Output, EventEmitter, Input, Injector } from '@angular/core';
import { of, Observable } from 'rxjs';
import { LogService } from 'src/app/log/log.service';

const myObservable = of('apple', 'orange', 'grappe');
const myObserver = {
    next: (x: string) => console.log('Observer got a next value: ' + x),
    error: (err: string) => console.error('Observer got an error: ' + err),
    complete: () => console.log('Observer got a complete notification')
  };

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent {
  @Input() label: string;
  sequence: Observable<string>;
  logService: LogService = this.injector.get(LogService);
  

  constructor(public logger: NGXLogger, private injector:Injector) {

    this.sequence = new Observable(this.sequenceSubscriber);
  }

  onClickButton(event) {
    this.logService.log().info('Hello Click');
    this.sequence.subscribe({
      next(msg) { console.log(msg); },
      complete() { console.log('Finished sequence'); }
    });
  }

  sequenceSubscriber(observer) {
    observer.next('Apple');
    observer.next('Orange');
    observer.next('Grappe');
    observer.complete();
    return {unsubscribe() {}};
  }
}

